export default {
  en: {
    departments: {
      title: 'Department',
      subtitle: 'Select a department to contact.',
      names: 'Department',
    },
    forms: {
      title: 'Personal data 📄',
      subtitle: 'For more personalized attention please provide some details about yourself.',
      empty: 'Not exist form for the selected department. Please modify template for view.',
    },
  },
  es: {
    departments: {
      title: 'Departamentos',
      subtitle: 'Seleccione el departamento a contactar.',
      names: 'Departamento',
    },
    forms: {
      title: 'Información 📄',
      subtitle: 'Para una atención más personalizada por favor, proporcione unos detalles sobre usted.',
      empty: 'No hay formulario para el departamento seleccionado. Modique la plantilla para visualizar.',
    },
  },
};
